const config = {
    'test': '',
'WORKFLOW_PIECES_BASE_URL': 'https://workflow-pieces-gksa.shipsy.io',
    'AGENT_FLOW_API_MAPPING': {
        'fkdemo:RIDERVERIFICATION_SELFIE_INITIATE': 'https://agentflow.shipsy.io/api/webhooks/trigger/f04d5c87-0d88-4daa-bbfb-1842962cab5d',
        'fkdemo:RIDERVERIFICATION_AADHAAR_VERIFY': 'https://agentflow.shipsy.io/api/webhooks/trigger/e358334f-796f-4215-8b20-0e457ee5562e',
        'fk:RIDERVERIFICATION_SELFIE_INITIATE': 'https://agentflow.shipsy.io/api/webhooks/trigger/5ec3a2ad-11c5-4d60-bb73-04851a3c07af',
        'fk:RIDERVERIFICATION_AADHAAR_VERIFY': 'https://agentflow.shipsy.io/api/webhooks/trigger/32e1aa35-e9c8-4cc1-bfdf-8c71cd51a42e',
    },
	firebase: {
		config: {
			apiKey: 'AIzaSyBS7-u48IAJzePDpwM-nbKNXULw8kD7HL4',
			authDomain: 'notification-service-418009.firebaseapp.com',
			projectId: 'notification-service-418009',
			storageBucket: 'notification-service-418009.appspot.com',
			messagingSenderId: '413910393309',
			appId: '1:413910393309:web:18279bf70b4ef30ee9d634',
		},
		firestoreDbId: 'notification-service-ksa-gcp-prod',
		vapidKey: 'BMJxxP73j8ok0wOvo5Ak_qked8D9oZW4-FhMsqie5JGh08HUvWcWpQKuX7vT2KIzQ9ahK7Q8ujQdcs15G7y8m4A',
	},
	notifications: {
        pollingInterval: 30000,
        pageSize: 10,
        maxDaysHistory: 30,
    },
};
module.exports = config;
